@if (profileService.canWriteMetadata()) {
  <mat-card class="h-100 overflow-hidden"
    appearance="outlined">
    <mat-card-header class="p-4">
      <div class="d-flex align-items-center justify-content-between w-100">
        <h4>{{ title }}</h4>
        <div class="d-flex align-items-center gap-3">
          @if (showAddButton) {
            <button
              mat-stroked-button
              (click)="onAdd()">
              <mat-icon class="material-symbols-outlined text-body">{{ addButtonIcon }} </mat-icon>
              {{ addButtonText }}
            </button>
          }
          @if (showRefreshButton) {
            <button
              mat-stroked-button
              (click)="onRefresh()">
              <mat-icon class="material-symbols-outlined text-body">refresh</mat-icon>
              Refresh
            </button>
          }
        </div>
      </div>
    </mat-card-header>
    @if (showFilterSection) {
      <div class="d-flex flex-column mb-2 px-4">
        <div class="d-flex justify-content-start align-items-center w-100 gap-3"
          [formGroup]="filterFormGroup">
        </div>
      </div>
    }
    @if (isProcessing) {
      <mat-progress-bar
      mode="indeterminate"></mat-progress-bar>
    }
    <mat-card-content class="d-flex flex-column gap-3 overflow-auto p-4 pt-0">
      <table mat-table
        matSort
        matSortActive="id"
        matSortDirection="desc"
        [dataSource]="dataSource ?? []">
        <!-- Dynamic columns -->
        @for (column of columns; track column) {
          <ng-container [matColumnDef]="column.key">
            <!-- Sortable header -->
            <th mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="column.sortActionDescription || 'Sort by ' + column.label"
              [ngClass]="{'sortable': column.sortable !== false}">
              {{ column.label }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ getColumnValue(element, column.key) }}
            </td>
          </ng-container>
        }
        <!-- Actions column -->
        @if (actions.length > 0) {
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              @for (action of actions; track action) {
                <button
                  mat-icon-button
                  [matTooltip]="action.tooltip"
                  (click)="onAction(action.action, element)">
                  <mat-icon [class]="action.materialSymbols !== false ? 'material-symbols-outlined text-body' : ''">
                    {{ action.icon }}
                  </mat-icon>
                </button>
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]"
        showFirstLastButtons>
      </mat-paginator>
    </mat-card-content>
  </mat-card>
}
